import { assetsPath } from "../../utils";

const video = `${assetsPath('phuket-laguna-park-2')}/images/concept/1.jpg`;

const title = {
  en: ["welcome", "to", "laguna"],
  cn: ["欢迎来到拉古浪物业"],
  ru: ["Добро пожаловать в", "Laguna Property"]
};

const subContent = {
  en: ["Whether for a primary or holiday residence, Laguna Property offers an appealing and incomparable lifestyle benefits."],
  cn: ["无论长期居住还是短期度假，拉古狼物业都能给您带来无与伦比的卓越生活享受。"],
  ru: ["Независимо от того, что вы ищете, - основное место проживания или место для отпуска - Laguna Property предлагает несравненно привлекательные преимущества."]
};

const content = {
  en: ["Perfectly situated to take advantage of Laguna resort's diverse choice of attractions and amenities, homeowners can enjoy discounts and privileged access to spas, restaurants, recreation and leisure facilities, and the World’s Championship in-resort golf course."],
  cn: ["坐拥优越的地理位置，拉古浪度假村拥有众多优美景点和便利设施。居住在此的业主可享受到折扣优惠，优先享受Spa, 餐饮和各类休闲娱乐设施以及世界顶级的高尔夫球场。"],
  ru: ["Благодаря идеальному расположению по отношению к разнообразным возможностям и удобствам курорта Laguna, владельцы могут наслаждаться скидками и привилегированным доступом к спа-центрам, ресторанам, местам для отдыха и развлечений, а также к полю для игры в гольф, соответствующему стандартам мировых чемпионатов."]
};

const button = {
  en:
    "Learn more >",
  cn:
    "了解更多 >",
  ru:
    "Подробнее >"
};

export default {
  title,
  subContent,
  content,
  button,
  video
};



// WEBPACK FOOTER //
// ./src/data/Home/concept.js